module.exports = __webpack_public_path__ + "img/BBF_example_fr.bccebe62.png";